export const DEFAULT_MAX_LENGTH = 5000;

export const SHOW_MAX_LENGTH_WARNING_THRESHOLD = 0.9;

export const MAX_LENGTH_REACHED_ALLOWED_KEYS = [
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
  'Tab',
  'Escape',
  'Enter',
] as const;
